import { useEffect } from 'react';

let holds = 0;

/** True while something on screen would be lost by a pull-to-refresh reload. */
export const pullToRefreshHeld = () => holds > 0;

/** Keeps pull-to-refresh off while `active`, e.g. during a live call, voice session or recording. */
export function useHoldPullToRefresh(active: boolean) {
  useEffect(() => {
    if (!active) return undefined;
    holds += 1;
    return () => { holds -= 1; };
  }, [active]);
}
